import { useNavigate } from '@tanstack/react-router';
import { Trans } from '@lingui/react/macro';
import { Home } from 'lucide-react';
import { ErrorDisplay } from '@/common/components/error-display/ErrorDisplay';
import { Button } from '@/common/components/ui/button';

export const NotFoundPage = () => {
  const navigate = useNavigate();
  return (
    <ErrorDisplay
      title={<Trans>Page not found</Trans>}
      message={<Trans>The page you are looking for does not exist.</Trans>}
      actions={
        <Button onClick={() => navigate({ to: '/' })}>
          <Home className="mr-2 h-4 w-4" />
          <Trans>Homepage</Trans>
        </Button>
      }
    />
  );
};
